import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function projectsPunch(geolocationId) {
    let url = 'punch/projects?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), geolocationId: geolocationId, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let projects = response.projects;

                //saveProjects(projects);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortProject(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.projectEn.toLowerCase() : a.projectFr.toLowerCase()
        const nameB = IsEnglish() ? b.projectEn.toLowerCase() : b.projectFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortProjectByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.project
        const nameB = b.project
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

// useCCQ flag values:
// O to list only CCQ projects
// N to list only non CCQ projects
// A to list both
export function filterProjectCCQ(data, useCCQ) {
    const tempData = [];

    data.forEach((project, index) => {
        if (useCCQ == "O") {
            if (project.isCCQ) {
                tempData.push(project);
            }
        }
        else if (useCCQ == "N") {
            if (!project.isCCQ) {
                tempData.push(project);
            }
        }
        else if (useCCQ == "A") {
            tempData.push(project);
        }
    });

    return tempData;
}


function saveProjects(config) {
    localStorage.setItem('punchProjects', JSON.stringify(config));
}